/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
import { css } from 'lit';
import { property } from 'lit/decorators.js';
import settings from '@carbon/ibmdotcom-utilities/es/utilities/settings/settings.js';
import styles from './logo-grid.scss';
import C4DCardLink from '../card-link/card-link';
import StableSelectorMixin from '../../globals/mixins/stable-selector';
import { carbonElement as customElement } from '@carbon/web-components/es/globals/decorators/carbon-element.js';

const { stablePrefix: c4dPrefix } = settings;

/**
 * Logo-grid-link.
 *
 * @element c4d-logo-grid-link
 */
@customElement(`${c4dPrefix}-logo-grid-link`)
class C4DLogoGridLink extends StableSelectorMixin(C4DCardLink) {
  /**
   * The shadow slot this link should be in.
   */
  @property({ reflect: true })
  slot = 'footer';

  static get stableSelector() {
    return `${c4dPrefix}--logo-grid-link`;
  }

  // `styles` here is a `CSSResult` generated by custom WebPack loader
  static get styles() {
    return css`
      ${super.styles}${styles}
    `;
  }
}

console.warn(
  'The logo-grid-link component has been deprecated in favor of the content-section/block and image-group component. ' + //TODO confirm new image-group or images in grid
    'See content-section/block and image-group documentation for more information.'
);

/* @__GENERATE_REACT_CUSTOM_ELEMENT_TYPE__ */
export default C4DLogoGridLink;
